import { render, staticRenderFns } from "./BoxTwo.vue?vue&type=template&id=a26063e0&scoped=true&"
import script from "./BoxTwo.vue?vue&type=script&lang=js&"
export * from "./BoxTwo.vue?vue&type=script&lang=js&"
import style0 from "./BoxTwo.vue?vue&type=style&index=0&id=a26063e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26063e0",
  null
  
)

export default component.exports